import { createMuiTheme } from '@material-ui/core/styles';

const primaryColor = {
  50: '#e4e5ed',
  100: '#bcbed3',
  200: '#8f93b5',
  300: '#626797',
  400: '#414781',
  500: '#1f266b',
  600: '#1b2263',
  700: '#171c58',
  800: '#12174e',
  900: '#0a0d3c',
  A100: '#747bff',
  A200: '#414bff',
  A400: '#0e1aff',
  A700: '#000cf4',
  contrastDefaultColor: 'light',
  contrastDarkColors: [
    50,
    100,
    200,
    'A100',
  ],
  contrastLightColors: [
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    'A200',
    'A400',
    'A700',
  ],
};

const theme = createMuiTheme({
  palette: {
    primary: primaryColor,
    primaryLight: 'rgba(31, 38, 107, 0.12)',
    primaryLighter: 'rgba(31, 38, 107, 0.54)',
  },
});

export const COLORS = {
  primaryColor: theme.palette.primary[500],
  primaryDarker: theme.palette.primary[700],
  primaryLight: theme.palette.primaryLight,
  primaryLighter: theme.palette.primaryLighter,
};

export const SHADOWS = theme.shadows;

export default theme;



// WEBPACK FOOTER //
// ./src/config/theme.js